// extracted by mini-css-extract-plugin
export var avatar = "_r4-3";
export var avatarContainer = "_r4-2";
export var avatarSpacer = "_r4-5";
export var avatarSpacerContainer = "_r4-4";
export var avatarStackContainer = "_r4-1";
export var bubble = "_r4-0";
export var remainderBubble = "_r4-6";